import React,{useRef} from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { DownloadGraphButton } from "../../ReusableComponents/CommonComponents";
import {DownloadGraphImage} from "../../ReusableComponents/CommonFunctions";
import { useSelector } from "react-redux";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);
const Multilinechart = (props) => {
    const chartRef = useRef(null);
  const USYear = useSelector((state) => state.SelecYearData.SYear);
const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const labels = [];
  const EnglishData = [];
  const MathsData = [];
  const ScienceData = [];
  const OptionalData =[];
  const TotalData = [];

  for (let i = 0; i < props.TrendsData?.length; i++) {
    if (props.TrendsData[i].assessmentType === 1) {
      labels.push([
        [props.TrendsData[i].assessmentTypeNo], `(${props.TrendsData[i]?.paperName})`
      ]);
    } else {
      labels.push([
        [props.TrendsData[i].assessmentTypeNo], `(${props.TrendsData[i]?.paperName})`
      ]);
    }
    EnglishData.push(props.TrendsData[i].englishPercenatage);
    MathsData.push(props.TrendsData[i].mathePercenatge);
    ScienceData.push(props.TrendsData[i].sciencePercentage);
    OptionalData.push(props.TrendsData[i].optionalLanguagePercentage);
    TotalData.push(props.TrendsData[i].overallPercentage);
  }
  const data = {
    labels,
    datasets: [
      { label: "English", data: EnglishData, borderColor: "rgb(255, 99, 132)", backgroundColor: "rgb(255, 99, 132)", },
      { label: "Mathematics", data: MathsData, borderColor: "#59C98A", backgroundColor: "#59C98A", },
      { label: "Science", data: ScienceData, borderColor: "#03A9F6", backgroundColor: "#03A9F6", },
     ... (items?.grade < 11 && props.TrendsData[0]?.optionalLanguage)?[ { label: props.TrendsData[0]?.optionalLanguage, data: OptionalData, borderColor: "#FFD700", backgroundColor: "#FFD700", }]:[],
      { label: "Total", data: TotalData, borderColor: "#025F9E", backgroundColor: "#025F9E", },
    ],
  };
  const options = {
    responsive: true,
    plugins: { legend: { position: "bottom" } },
    scales: {
      x: {
        offset: 20,
        gridLines: { offsetGridLines: true },
        stacked: false,
        title: {
          display: true,
          text: "Assessment Date",
          marginTop: 10,
          padding: { top: 10, bottom: 10, },
        },
        grid: { display: false, },
      },
      y: {
        max: 100,
        stacked: false,
        title: { display: true, text: "Subject wise %", },
        beginAtZero: true,
      },
    },
  };
 const DownloadPTrends = (e) => {
    DownloadGraphImage(chartRef, `Student Performance Trends -${process.env.REACT_APP_NCLEXAMDISPLAYNAME1} and ${process.env.REACT_APP_NCLEXAMDISPLAYNAME2} - ${USYear?.display}`)
  };
  return <>{labels &&
    <>
      <div className="dflex JSBetween">
        <div></div>
       {props.TrendsData.length>0 &&  <DownloadGraphButton  Click={() => DownloadPTrends()}/>}
      </div>

      <Line options={options} data={data}  ref={chartRef}/></>}</>;
};
export default Multilinechart;
